const looksLikeDate = value => value?.match(/^\w+ ?[/-] ?\w+( ?[/-] ?\w+)$/);
export default looksLikeDate;
